import QdContainer from 'components/Common/QdContainer'
import React from 'react'
import Header from './Header'
import { Card, CardBody } from 'reactstrap'
import NotificationConfig from './NotificationConfig'
import { Provider as NotificationProvider } from './NotificationContext'

const NotificationManagement = () => {
    return (
        <NotificationProvider>
            <QdContainer>
                <Card>
                    <CardBody>
                        <Header />
                        <div className="mt-3">
                            <NotificationConfig />
                        </div>
                    </CardBody>
                </Card>
            </QdContainer>
        </NotificationProvider>
    )
}

export default NotificationManagement